import { useViewportSize } from '@mantine/hooks';

export function useIsMobile(maxWidth?: number) {
  const { width } = useViewportSize();
  return width < (maxWidth ? maxWidth : 600);
}
